<template>
  <WsUpdate
    :modelName="modelName"
    :id="$route.params.id"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    editType="createVersion"
    titleKey="last_version.name"
    :customParentData="customParentData"
    :hasCatchVersion="hasCatchVersion"
    :submodelVersionName="submodelVersionName"
    :submodelName="submodelName"
  >
  </WsUpdate>
</template>

<script>
import model from "@/models/change_item_template";
import submodel from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    submodelName: submodel.modelName,
    submodelVersionName: submodel.versionModelName,
    label: model.label,
    fields: model.fields,
    hasCatchVersion: true,
    customParentData: (parentData) => {
      return {
        area: parentData.area,
      };
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "變因資訊",
              fields: ["last_version"],
            },
          ],
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類設定",
              fields: ["areas", "industry_categories"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "設定",
              remark: "隱藏的內容將不會顯示於使用者前台介面",
              fields: ["is_active"],
            },
          ],
        },
      ],
    },
  }),
};
</script>